import { render, staticRenderFns } from "./StudentBinding.vue?vue&type=template&id=b21a5412&scoped=true"
import script from "./StudentBinding.vue?vue&type=script&lang=js"
export * from "./StudentBinding.vue?vue&type=script&lang=js"
import style0 from "./StudentBinding.vue?vue&type=style&index=0&id=b21a5412&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21a5412",
  null
  
)

export default component.exports